var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormAdd" } }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "text-container" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("form.formPublish.add"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            _vm._s(_vm.$t("form.formPublish.formAddDesc")) +
              "\n                yerleştirin.\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-iframe", on: { click: _vm.toggleExpand } }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "text-section" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("form.formPublish.iframe"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.$t("form.formPublish.iframeDesc"))),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(2),
    ]),
    _vm._v(" "),
    _vm.expanded
      ? _c("div", { staticClass: "code-section" }, [
          _c("pre", [_vm._v(_vm._s(_vm.iframeCode))]),
          _vm._v(" "),
          _c("button", { on: { click: _vm.copyCode } }, [
            _vm._v(_vm._s(_vm.$t("message.copy"))),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-pop-up", on: { click: _vm.openPopUp } }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "text-section" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("form.formPublish.openWindow"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.$t("form.formPublish.openWindowDesc"))),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(4),
    ]),
    _vm._v(" "),
    _vm.popup
      ? _c("div", { staticClass: "code-section" }, [
          _c("pre", [_vm._v(_vm._s(_vm.popUpCode))]),
          _vm._v(" "),
          _c("button", { on: { click: _vm.copyPopUp } }, [
            _vm._v(_vm._s(_vm.$t("message.copy"))),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("code")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-section" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("view_in_ar")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-section" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("chevron_right")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-section" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("open_in_new")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-section" }, [
      _c("i", { staticClass: "md-icon" }, [_vm._v("chevron_right")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }